/**
 * One line above a recording's ECG saying what the sequence's apnea screening
 * found in THIS recording, with a link to the sequence report where the
 * screening is actually assessed (project_management#555). Renders nothing
 * when there is no screening for the recording or the feature is off.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';

import { RecordingApneaScreening, apneaNotice, sequenceReportPath } from './recordingApnea';

export function RecordingApneaNotice({
  screening,
}: {
  screening: RecordingApneaScreening | null | undefined;
}) {
  const { t } = useTranslation();
  const notice = apneaNotice(screening);

  if (!notice || !screening) return null;

  const { key, ...values } = notice;

  return (
    <Alert
      data-testid="recording-apnea-notice"
      icon={false}
      severity="info"
      style={{ marginBottom: 8 }}
    >
      <Typography variant="subtitle2">{t('recordingApnea.title')}</Typography>
      <Typography variant="body2">{t(key, values)}</Typography>
      <Typography color="textSecondary" variant="caption">
        {t('recordingApnea.caption')}{' '}
        <Link component={RouterLink} to={sequenceReportPath(screening.sequenceId)}>
          {t('recordingApnea.openSequence')}
        </Link>
      </Typography>
    </Alert>
  );
}
